/* eslint-disable */
import Component from 'gia/Component'
import 'video.js'
import 'videojs-youtube'
export default class ComponentVideo extends Component {
  constructor(element) {
    super(element)
  }

  mount() {}
}



// WEBPACK FOOTER //
// ./scripts/components/Video.js